module.exports = __webpack_public_path__ + "static/media/budget-planning.0e41f49f.png";